export default function() {
  return new Worker(__webpack_public_path__ + "search.worker-f18e766ff7d9b91e1072.worker.js");
}
